/* Teeinblue measures its gallery before adding the enabled-theme body class.
 * Remeasure when the final column width changes, including editor/device resize.
 */
(function () {
  if (!window.ResizeObserver || window.__mangofyGalleryLayout) return;
  window.__mangofyGalleryLayout = true;
  var widths = new WeakMap();
  var observed = new WeakSet();
  var frame;
  var resize = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var width = Math.round(entry.contentRect.width);
      if (!width || widths.get(entry.target) === width) return;
      widths.set(entry.target, width);
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
    });
  });
  function connect() {
    document.querySelectorAll('.product-media-wrapper > .tee-gallery-content').forEach(function (gallery) {
      if (observed.has(gallery)) return;
      observed.add(gallery);
      resize.observe(gallery);
    });
  }
  connect();
  new MutationObserver(connect).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
